<template>
  <Widget class="bg-red-600 text-white border-red-700">
    <WidgetHeader class="bg-red-600 text-white"
      ><span class="text-white">Are you sure?</span></WidgetHeader
    >
    <WidgetBody>
      <h5 class="text-yellow-400 font-bold">This action cannot be undone.</h5>
      <h5>
        Please confirm you'd like to
        <span class="text-yellow-400 font-bold">DELETE</span> the Nameserver
        Relation with the following details:
      </h5>
      <ul class="text-xs mt-4 mb-3">
        <li>Prefix: {{ this.prefix }}</li>
        <li>Server Host Name: {{ this.hostname }}</li>
        <li>Ip: {{ this.ip }}</li>
      </ul>
    </WidgetBody>
    <WidgetFooter class="bg-dark-transparent-1 flex justify-between py-2 px-4">
      <YButton class="hover:bg-red-700 focus:bg-red-700" @click="$emit('close')"
        >Cancel</YButton
      >
      <YButton
        @click="update"
        class="hover:bg-red-700 focus:bg-red-700"
        :is-loading="isSubmitting"
        >Delete Relation</YButton
      >
    </WidgetFooter>
  </Widget>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    ip: {
      type: String,
      required: true
    },
    hostname: {
      type: String,
      required: true
    },
    prefix: {
      type: String,
      required: true
    }
  },
  components: {},
  apollo: {},
  data() {
    return {
      isSubmitting: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    update() {
      this.isSubmitting = true

      this.$apollo
        .mutate({
          mutation: gql`
            mutation YdnsDeleteDomainNameserver($id: ID!) {
              ydnsDeleteDomainNameserver(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.id
          }
        })
        .then(() => {
          this.isSubmitting = false
          this.$events.emit('refreshDnsDomains', true)
          this.$emit('close')
        })
        .catch(error => {
          console.log(error)
          this.isSubmitting = false
        })
    }
  },
  mounted() {},
  updated() {}
}
</script>
<style scoped>
.text-opacity-light {
  opacity: 0.7;
}
.bg-danger .text-warning {
  color: #ffd800 !important;
}
.bg-dark-transparent-1 {
  background: rgba(0, 0, 0, 0.1);
}
</style>
